import { axios } from "@/libraries/axios";
import type {
	GetRemindersParamsSchema,
	PutReminderCheckBodySchema,
	ReminderFormFieldSchema,
} from "@/schemas";
import type {
	GetReminderResponse,
	GetRemindersResponse,
	PostCreateReminderResponse,
} from "@/types";
import dayjs from "dayjs";

class ReminderService {
	async reminders(params?: GetRemindersParamsSchema) {
		try {
			const res = await axios.get<GetRemindersResponse>("/api/v1/reminders", {
				params,
			});
			return res.data;
		} catch (error) {
			return Promise.reject(error);
		}
	}

	async detail(id: number) {
		try {
			const res = await axios.get<GetReminderResponse>(
				`/api/v1/reminders/${id}`,
			);
			return res.data;
		} catch (error) {
			return Promise.reject(error);
		}
	}

	async check(payload: PutReminderCheckBodySchema) {
		try {
			const { id } = payload;
			const res = await axios.put<GetRemindersResponse>(
				`/api/v1/reminders/${id}/check`,
			);
			return res.data;
		} catch (error) {
			return Promise.reject(error);
		}
	}

	async create(reminder: ReminderFormFieldSchema) {
		try {
			if (reminder.alarm) {
				reminder.alarm = dayjs(reminder.alarm).format("DD-MM-YYYY HH:mm:ss Z");
			}
			const res = await axios.post<PostCreateReminderResponse>(
				"/api/v1/reminders",
				reminder,
			);
			return res.data;
		} catch (error) {
			return Promise.reject(error);
		}
	}

	async update(reminder: ReminderFormFieldSchema) {
		try {
			const id = reminder.id;
			if (reminder.alarm) {
				reminder.alarm = dayjs(reminder.alarm).format("DD-MM-YYYY HH:mm:ss Z");
			}
			if (!id) return Promise.reject("Reminder ID is required");
			const res = await axios.patch<PostCreateReminderResponse>(
				`/api/v1/reminders/${id}`,
				reminder,
			);
			return res.data;
		} catch (error) {
			return Promise.reject(error);
		}
	}

	async delete(id: number) {
		try {
			const res = await axios.delete<GetReminderResponse>(
				`/api/v1/reminders/${id}`,
			);
			return res.data;
		} catch (error) {
			return Promise.reject(error);
		}
	}
}

export const reminderService = Object.freeze(new ReminderService());
